/**
 * Institutes allowed to see Tabexawy AI UI (chat, generate copy).
 * Add more instids here when rolling the feature out.
 *
 * Hosts: manage dashboards only (plus localhost for local manage).
 * Voice + health-check (eval) UI is limited to AI_VOICE_EVAL_INSTITUTE_IDS.
 * Image Studio (local crop/mark/text/adjust) follows the same host gate.
 * Studio AI edits are controlled by STUDIO_AI_ENABLED below.
 */
export const AI_ALLOWED_INSTITUTE_IDS = ['6344167a3a92e'
     ,'68ac3324506ec'
    ];

/** Production dashboards that may show Tabexawy. Localhost is the manage app in dev. */
export const AI_ALLOWED_HOSTS = ['manage.tabexseries.com', 'manage.tabapv.site'];

/** Voice call + Tabexawy health-check panel only. */
export const AI_VOICE_EVAL_INSTITUTE_IDS = ['6344167a3a92e'];

/** Flip on when re-enabling AI edits inside Image Studio. */
export const STUDIO_AI_ENABLED = false;

export function isAiAllowedHost(hostname) {
    const host = String(
        hostname ?? (typeof window !== 'undefined' ? window.location.hostname : ''),
    )
        .toLowerCase()
        .replace(/^www\./, '')
        .trim();
    if (!host) return false;
    if (host === 'localhost' || host === '127.0.0.1') return true;
    return AI_ALLOWED_HOSTS.includes(host);
}

export function isAiAllowedInstitute(instid) {
    if (!isAiAllowedHost()) return false;
    const id = String(instid || '').trim();
    return Boolean(id) && AI_ALLOWED_INSTITUTE_IDS.includes(id);
}

/** Voice + eval/test UI only (stricter than chat allowlist). */
export function isAiVoiceEvalInstitute(instid) {
    if (!isAiAllowedHost()) return false;
    const id = String(instid || '').trim();
    return Boolean(id) && AI_VOICE_EVAL_INSTITUTE_IDS.includes(id);
}

/** Studio UI — manage dashboards only. */
export function isImageStudioAllowed() {
    return isAiAllowedHost();
}

/** Whether the AI tab/tools inside Image Studio are shown. */
export function isStudioAiEnabled(instid) {
    if (!STUDIO_AI_ENABLED) return false;
    return isAiAllowedInstitute(instid);
}
